import React, { useState } from "react";

import { Group, TextInput, Button, Divider } from "@mantine/core";

export default function CouponButton({ hideDivider, onApplyCode }) {
  const [addCoupon, setAddCoupon] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  return (
    <>
      <Group>
        {addCoupon && (
          <TextInput
            mt={10}
            placeholder="DISCOUNT1212"
            value={couponCode}
            onChange={(event) => setCouponCode(event.currentTarget.value)}
            onClick={(event) => event.stopPropagation()}
          />
        )}
        <Button
          mt={10}
          variant="outline"
          onClick={(event) => {
            if (addCoupon) {
              if (typeof onApplyCode === "function") {
                onApplyCode(event, couponCode);
              }
            } else {
              event.stopPropagation();
              setAddCoupon(true);
            }
          }}
        >
          {addCoupon ? "Apply coupon" : "+ Add coupon"}
        </Button>
      </Group>
      <Divider
        sx={(theme) => ({ borderTopColor: hideDivider ? "transparent" : theme.colors.gray[2] })}
        mt={20}
        mb={15}
      />
    </>
  );
}
